import {  useContext, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { LoadingSpinner, TabMenu } from '../components/BaseComponents'
import PageHeadings from '../components/BaseComponents/PageHeadings/PageHeadings'
import PageTemplate from '../components/BaseComponents/PageTemplate/PageTemplate'
import InvitationsTable from '../components/InvitationsTable/InvitationsTable'
import routes from '../components/Router/routes'
import { getReceivedInvitations } from '../redux/actions/companyReceivedInvitationsActions'
import { getSentInvitations } from '../redux/actions/companySentInvitationsActions'
import { useAppDispatch, useAppSelector } from '../redux/hooks/reduxHooks'
import {
	selectReceivedInvitations,
	selectReceivedInvitationsStatus,
} from '../redux/slices/companyReceivedInvitationsSlice'
import {
	selectInvitations,
	selectInvitationsStatus,
} from '../redux/slices/companySentInvitationsSlice'
import { FetchStatus } from '../types/LoadingStates'
import { userContext } from '../context/UserContext'
import useApi from '../hooks/useApi'
import AdvisorsTable from '../components/AdvisorsTable'

const tabOptions = [
	{ id: 'To Suppliers', label: 'To Suppliers' },
	{ id: 'From Customers', label: 'From Customers' },
	{ id: 'From Advisors', label: 'From Advisors' },
]

export const CompanySupplyChain = () => {
	const dispatch = useAppDispatch()
	const api = useApi();
	const { companyAssumption } = useContext(userContext)

	const allInvitations = useAppSelector(selectInvitations)
	const invitationsStatus = useAppSelector(selectInvitationsStatus)

	const allReceivedInvitations = useAppSelector(selectReceivedInvitations)
	const invitationsReceivedStatus = useAppSelector(selectReceivedInvitationsStatus)

	useEffect(() => {
		dispatch(getSentInvitations(api))
		dispatch(getReceivedInvitations(api))
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const [tab, setTab] = useState('To Suppliers')

	return (
		<PageTemplate>
			<Helmet>
				<title>{routes.companySupplyChainRequests.name}</title>
			</Helmet>
			<PageHeadings title="External Network" />

			<TabMenu
				tabs={tabOptions}
				ariaLabel='Tabs'
				value={tab}
				onChange={setTab}
				additionalClass='mt-9 hidden sm:block'
			/>
			{tab === 'To Suppliers' && (
				<>
					{invitationsStatus === FetchStatus.loading && <LoadingSpinner />}

					{/* Loaded */}
					{invitationsStatus === FetchStatus.loaded && allInvitations.length > 0 && (
						<InvitationsTable type='Company' invitations={allInvitations} />
					)}
					{invitationsStatus === FetchStatus.loaded && allInvitations.length === 0 && (
						<>
							<p className='text-white px-4 py-2 mt-2'>We did not find any sent invitations.</p>
						</>
					)}

					{/* Error */}
					{invitationsStatus === FetchStatus.error && (
						<p className='my-lg text-white'>
							Oops! There was an error fetching the invitations data sent to Suppliers.
						</p>
					)}
				</>
			)}
			{tab === 'From Customers' && (
				<>
					{invitationsReceivedStatus === FetchStatus.loading && <LoadingSpinner />}

					{/* Loaded */}
					{invitationsReceivedStatus === FetchStatus.loaded &&
						allReceivedInvitations.length > 0 && (
							<InvitationsTable
								invitations={allReceivedInvitations}
								type='CompanyReceivedInvitations'
							/>
						)}
					{invitationsReceivedStatus === FetchStatus.loaded &&
						allReceivedInvitations.length === 0 && (
							<>
								<p className='text-white px-4 py-2 mt-2'>
									We did not find any received invitations.
								</p>
							</>
						)}

					{/* Error */}
					{invitationsReceivedStatus === FetchStatus.error && (
						<p className='my-lg text-white'>
							Oops! There was an error fetching the received invitations.
						</p>
					)}
				</>
			)}
			{tab === 'From Advisors' &&
				(companyAssumption ? (
					<p className='my-lg text-white'>
						Advisor access is managed from the organisation's own account and cannot be viewed while acting on its behalf.
					</p>
				) : (
					<AdvisorsTable />
				))}
		</PageTemplate>
	)
}

export default CompanySupplyChain
